import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataElement } from "src/app/shared/models/common";
import { AppState } from "src/app/shared/redux/store";
import { LabKpiComponent } from "../lab-kpi.component";
import { Store } from "@ngrx/store";
import { agentsList } from "src/app/shared/ngrx/ngrx-selectors";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ClearMultiComponent } from "src/app/shared/components/ui/clear-multi.component";

@Component({
  selector: "app-kpi-agents",
  templateUrl: "./kpi-agents.component.html",
  styleUrls: ["./kpi-agents.component.scss"],
  imports: [
    SelectModule,
    InputWrapComponent,
    TranslateModule,
    FormsModule,
    CommonModule,
    ClearMultiComponent,
    LabKpiComponent,
  ],
  standalone: true,
})
export class KpiAgentsComponent implements OnInit {
  @ViewChild("agentsKpi") cmpAgentsKpi: LabKpiComponent;

  selectedAgent: DataElement;
  filter: string;
  filterType: string;
  loading: boolean;

  get agentsList(): DataElement[] {
    return this.store.selectSignal(agentsList)();
  }

  constructor(private readonly store: Store, private router: Router) { }

  ngOnInit(): void { }

  search() {
    if (!this.selectedAgent) {
      this.filterType = null;
      return;
    }

    this.loading = true;

    setTimeout(() => {
      this.filterType = "AGENT";
      this.filter = this.selectedAgent.id;
      this.loading = false;

      if (this.cmpAgentsKpi) {
        this.cmpAgentsKpi.getData();
      }
    }, 100);
  }
}
